export interface IMinistryResource extends ng.resource.IResourceClass<any> {
  addAgency: Function;
  updateAgency: Function;
  removeAgency: Function;
  update: Function;
  updateAll: Function;
}

export class MinistryService {
  public static $inject: Array<string> = ["$resource"];
  public ministryService: ng.resource.IResourceClass<any>;
  constructor(private $resource: any) {
    let ministryService =  $resource(`${BASE}/api/ministry/:ministryId`, {ministryId: '@id'},
    {
      update: {
        method: "PUT"
      },
      updateAll: {
        method: "PATCH",
        isArray: true
      },
      addAgency: {
        url: `${BASE}/api/ministry/:ministryId/agency`,
        params: {ministryId: '@id'},
        method: "POST"
      },
      updateAgency: {
        url: `${BASE}/api/ministry/:ministryId/agency`,
        params: {ministryId: '@id'},
        method: "PUT"
      },
      removeAgency: {
        url: `${BASE}/api/ministry/:ministryId/agency`,
        params: {ministryId: '@id'},
        method: "DELETE"
      }
    });
    this.ministryService = ministryService;
    return ministryService;
  }
}
